import { h, Component } from "preact";
import { css } from "emotion";
import IconArrowDown from "../../assets/images/icon-arrow-down.svg";
import IconArrowUp from "../../assets/images/icon-arrow-up.svg";
const heading = css({
  textTransform: "capitalize",
  fontWeight: 600
});

const wrapper = css`
  width: 100%;
  padding: 24px 10px 18px 20px;
  background-color: #fff;
  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);
  min-width: 280px;
  display: inline-block;
  border-radius: 4px;
  margin-bottom: 12px;
  @media (max-width: 1000px) {
    padding: 14px;
  }
  @media (max-width: 600px) {
    margin-top: 208px;
    margin-bottom: 16px;
  }
`;

const descriptionText = css({
  textAlign: "left",
  overflowWrap: "break-word",
  wordBreak: "break-all",
  wordBreak: "break-word",
  hyphens: "auto"
});

class OrganiserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { showMore: false };
  }
  clickShowMore = () => {
    this.setState({ showMore: !this.state.showMore });
  };
  render() {
    let { description } = this.props;
    const { showMore } = this.state;

    const tooLong = description && description.length > 182 ? true : false;
    if (tooLong && !showMore) {
      description = description.substring(0, 182) + "...";
    }
    return (
      <div>
        <div className={wrapper}>
          <h2 className={heading}>About</h2>
          {description && description !== "" ? (
            <p className={descriptionText}>{description}</p>
          ) : null}
          {tooLong && !showMore ? (
            <button onClick={this.clickShowMore} style={{ padding: 0 }}>
              Read more{" "}
              <img src={IconArrowDown} style={{ width: 12, marginLeft: 6 }} />{" "}
            </button>
          ) : null}
          {tooLong && showMore ? (
            <button onClick={this.clickShowMore} style={{ padding: 0 }}>
              Show less{" "}
              <img src={IconArrowUp} style={{ width: 12, marginLeft: 6 }} />{" "}
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default OrganiserInfo;



// WEBPACK FOOTER //
// ./routes/organiser/OrganiserInfo.js